import React from 'react';
import { Check, ChevronDown, AlertTriangle, ArrowRight, Lock, ShieldCheck, Star } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { TestimonialsSection } from './TestimonialsSection';
const PURCHASE_URL = 'https://pagos.avanzalab.online/cart/52985716146490:1';
const IMAGES = {
  main: 'https://cdn.magicpatterns.com/uploads/trXdiWW51DqyTEnYYbVT82/Diseno_sin_titulo.png',
  bonus1: 'https://cdn.magicpatterns.com/uploads/ggkoS8M9n3HPDgUJqML2cW/ChatGPT_Image_6_feb_2026,_19_55_05.png',
  bonus2: 'https://cdn.magicpatterns.com/uploads/hvbnBMnTpyVFBtaANqg6Du/ChatGPT_Image_6_feb_2026,_19_58_38.png',
  bonus3: 'https://cdn.magicpatterns.com/uploads/uuJxSu4QrbdxXqMVwnRXh8/ChatGPT_Image_6_feb_2026,_20_00_31.png'
};
const CTAButton = ({
  text,
  subtext,
  className = ''
}: {
  text: string;
  subtext?: string;
  className?: string;
}) => <a href={PURCHASE_URL} className={`block w-full max-w-md mx-auto bg-gradient-to-b from-yellow-400 to-yellow-500 hover:from-yellow-300 hover:to-yellow-400 text-gray-900 text-center py-4 px-6 rounded-lg shadow-xl transform transition hover:scale-105 border-b-4 border-yellow-700 ${className}`} data-id="element-9">
    <span className="block text-2xl md:text-3xl font-black uppercase tracking-tight" data-id="element-10">
      {text}
    </span>
    {subtext && <span className="block text-sm font-semibold mt-1 opacity-90" data-id="element-11">
        {subtext}
      </span>}
  </a>;
export function SalesPage() {
  return <div className="min-h-screen bg-[#080c24] font-sans text-gray-100" data-id="element-12">
      {/* SECTION 1 - HERO */}
      <section className="bg-[#0a0e2a] py-12 px-4 md:py-16 border-b-4 border-cyan-500" data-id="element-13">
        <div className="max-w-3xl mx-auto text-center space-y-6" data-id="element-14">
          <div className="inline-block bg-red-600 text-white px-4 py-1 font-bold uppercase tracking-widest text-sm rounded mb-4 animate-pulse" data-id="element-15">
            NUEVO LANZAMIENTO
          </div>

          <h1 className="text-4xl md:text-6xl font-black text-white leading-tight" data-id="element-16">
            🔥 MEGA PACK
            <br data-id="element-17" />
            <span className="text-cyan-400" data-id="element-18">EL INFLUENCER INVISIBLE</span>
          </h1>

          <h2 className="text-2xl md:text-3xl font-bold text-gray-100" data-id="element-19">
            El nuevo modelo de creador digital que está reemplazando al
            influencer tradicional…
          </h2>

          <a href={PURCHASE_URL} className="block hover:opacity-95 transition" data-id="element-20">
            <img src={IMAGES.main} alt="Mega Pack Influencer Invisible" className="w-full max-w-xl mx-auto rounded-xl shadow-[0_0_40px_rgba(0,200,255,0.3)] my-8 border-2 border-cyan-500/40" data-id="element-21" />
          </a>

          <p className="text-xl md:text-2xl text-gray-300 font-medium" data-id="element-22">
            Creá una presencia online real usando inteligencia artificial.
          </p>

          <div className="bg-[#111640] p-4 rounded-lg inline-block mx-auto border-l-4 border-cyan-500" data-id="element-23">
            <p className="text-lg font-semibold text-gray-200" data-id="element-24">
              Sin mostrar tu cara. Sin exponerte. Sin convertir tu vida personal
              en contenido.
            </p>
          </div>

          <div className="pt-6" data-id="element-25">
            <CTAButton text="👉 QUIERO ACCEDER AHORA" subtext="Acceso inmediato al sistema completo" data-id="element-26" />
          </div>
        </div>
      </section>

      {/* SECTION 2 - PROBLEM */}
      <section className="bg-[#0a0e2a] py-16 px-4" data-id="element-27">
        <div className="max-w-3xl mx-auto" data-id="element-28">
          <div className="bg-red-950/40 border-l-8 border-red-600 p-6 md:p-8 rounded-r-lg shadow-sm mb-12" data-id="element-29">
            <h3 className="text-2xl md:text-3xl font-bold text-red-400 flex items-center gap-3 mb-4" data-id="element-30">
              <AlertTriangle className="w-8 h-8 md:w-10 md:h-10 shrink-0" data-id="element-31" />
              🚨 Algo está cambiando en internet (y casi nadie lo está diciendo)
            </h3>
            <p className="text-lg text-gray-200 mb-4" data-id="element-32">
              Durante años nos hicieron creer que para crecer online había que:
            </p>
            <ul className="space-y-2 font-semibold text-gray-300 ml-6 list-disc" data-id="element-33">
              <li data-id="element-34">mostrar la cara</li>
              <li data-id="element-35">hablar frente a cámara</li>
              <li data-id="element-36">exponer la vida personal.</li>
            </ul>
          </div>

          <div className="text-center space-y-6" data-id="element-37">
            <p className="text-2xl font-bold text-white" data-id="element-38">
              Pero algo empezó a cambiar.
            </p>
            <p className="text-xl text-gray-300" data-id="element-39">
              Cada vez más cuentas crecen…
            </p>

            <div className="py-4" data-id="element-40">
              <span className="bg-cyan-600 text-white text-3xl md:text-4xl font-black px-6 py-3 transform -rotate-2 inline-block shadow-[0_0_20px_rgba(0,200,255,0.4)]" data-id="element-41">
                SIN ROSTRO
              </span>
            </div>

            <p className="text-xl text-gray-300" data-id="element-42">
              Sin exposición personal.
              <br data-id="element-43" />
              Sin depender de una persona real frente a cámara.
            </p>

            <div className="bg-[#111640] p-6 rounded-xl border border-cyan-800/40 mt-8" data-id="element-44">
              <p className="text-lg font-medium text-gray-400" data-id="element-45">
                No es suerte. No es magia.
              </p>
              <p className="text-2xl font-bold text-cyan-300 mt-2" data-id="element-46">
                Es un nuevo modelo:
              </p>
              <h3 className="text-3xl md:text-4xl font-black text-cyan-400 mt-2 uppercase" data-id="element-47">
                👉 EL INFLUENCER INVISIBLE.
              </h3>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 3 - BIG IDEA */}
      <section className="bg-[#080c24] py-16 px-4 border-t border-cyan-900/30" data-id="element-48">
        <div className="max-w-3xl mx-auto" data-id="element-49">
          <h3 className="text-3xl font-black text-center text-white mb-8 flex items-center justify-center gap-3" data-id="element-50">
            🧠 La BIG IDEA
          </h3>

          <div className="prose prose-lg mx-auto text-gray-300" data-id="element-51">
            <p className="font-bold text-xl text-center mb-8 text-gray-100" data-id="element-52">
              No necesitás ser la cara. Necesitás construir una identidad
              digital diseñada para funcionar.
            </p>

            <p data-id="element-53">
              La mayoría falla porque intenta ser influencer tradicional. Pero
              el problema es ese modelo. No está hecho para todos.
            </p>

            <p className="mt-4" data-id="element-54">Y por eso muchas personas:</p>

            <div className="bg-[#111640] p-6 rounded-lg shadow-sm border border-cyan-900/30 my-6 space-y-3" data-id="element-55">
              <div className="flex items-start gap-3" data-id="element-56">
                <div className="bg-red-900/40 p-1 rounded text-red-400 mt-1" data-id="element-57">
                  <Check className="w-4 h-4" data-id="element-58" />
                </div>
                <p className="text-gray-300" data-id="element-59">
                  leen sobre crear contenido…{' '}
                  <span className="font-bold text-white" data-id="element-60">
                    pero nunca empiezan.
                  </span>
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-61">
                <div className="bg-red-900/40 p-1 rounded text-red-400 mt-1" data-id="element-62">
                  <Check className="w-4 h-4" data-id="element-63" />
                </div>
                <p className="text-gray-300" data-id="element-64">
                  guardan ideas…{' '}
                  <span className="font-bold text-white" data-id="element-65">
                    pero no publican.
                  </span>
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-66">
                <div className="bg-red-900/40 p-1 rounded text-red-400 mt-1" data-id="element-67">
                  <Check className="w-4 h-4" data-id="element-68" />
                </div>
                <p className="text-gray-300" data-id="element-69">
                  abren redes…{' '}
                  <span className="font-bold text-white" data-id="element-70">
                    y las cierran sin hacer nada.
                  </span>
                </p>
              </div>
            </div>

            <p className="text-center font-semibold text-xl text-gray-200" data-id="element-71">
              No porque no puedan. <br data-id="element-72" />
              <span className="text-cyan-400" data-id="element-73">
                Porque no encontraron una forma que se sienta natural.
              </span>
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 4 - PARADIGM SHIFT */}
      <section className="bg-[#0a0e2a] py-16 px-4" data-id="element-74">
        <div className="max-w-3xl mx-auto text-center" data-id="element-75">
          <h3 className="text-3xl md:text-4xl font-black text-white mb-8" data-id="element-76">
            🔥 El cambio de paradigma
          </h3>

          <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-77">
            <div className="bg-[#111640] p-6 rounded-xl border border-gray-700/30" data-id="element-78">
              <p className="text-gray-500 font-bold uppercase text-sm mb-2" data-id="element-79">
                Antes pensabas:
              </p>
              <p className="text-xl font-medium text-gray-500 line-through decoration-red-500 decoration-2" data-id="element-80">
                Es esconderse.
              </p>
            </div>
            <div className="bg-emerald-950/40 p-6 rounded-xl border border-emerald-700/40 shadow-sm" data-id="element-81">
              <p className="text-emerald-400 font-bold uppercase text-sm mb-2" data-id="element-82">
                La realidad:
              </p>
              <p className="text-2xl font-bold text-emerald-300" data-id="element-83">Es diseñar.</p>
            </div>
          </div>

          <div className="mt-10 space-y-4" data-id="element-84">
            <p className="text-2xl font-medium text-gray-200" data-id="element-85">
              Crear una presencia coherente.
            </p>
            <p className="text-2xl font-medium text-gray-200" data-id="element-86">Humana.</p>
            <p className="text-2xl font-bold text-cyan-400 bg-[#111640] inline-block px-4 py-2 rounded-lg border border-cyan-800/30" data-id="element-87">
              Y capaz de crecer sin depender de tu exposición personal.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 5 - UNCOMFORTABLE TRUTH (Dark) */}
      <section className="bg-[#060920] text-white py-16 px-4" data-id="element-88">
        <div className="max-w-3xl mx-auto" data-id="element-89">
          <h3 className="text-3xl font-bold text-yellow-400 mb-8 flex items-center gap-3" data-id="element-90">
            ⚠️ La verdad incómoda
          </h3>

          <p className="text-xl mb-8 text-gray-300" data-id="element-91">
            La gente no abandona porque le falte talento. Abandona porque:
          </p>

          <div className="grid md:grid-cols-3 gap-4 mb-10" data-id="element-92">
            <div className="bg-[#0d1040] p-4 rounded border border-purple-800/40 text-center" data-id="element-93">
              <span className="text-red-500 text-2xl font-bold block mb-2" data-id="element-94">
                ❌
              </span>
              <span className="font-bold" data-id="element-95">no tiene sistema</span>
            </div>
            <div className="bg-[#0d1040] p-4 rounded border border-purple-800/40 text-center" data-id="element-96">
              <span className="text-red-500 text-2xl font-bold block mb-2" data-id="element-97">
                ❌
              </span>
              <span className="font-bold" data-id="element-98">improvisa contenido</span>
            </div>
            <div className="bg-[#0d1040] p-4 rounded border border-purple-800/40 text-center" data-id="element-99">
              <span className="text-red-500 text-2xl font-bold block mb-2" data-id="element-100">
                ❌
              </span>
              <span className="font-bold" data-id="element-101">usa IA sin dirección</span>
            </div>
          </div>

          <p className="text-lg text-gray-300 mb-4" data-id="element-102">Intentan:</p>
          <ul className="list-disc ml-6 space-y-2 text-gray-400 mb-8" data-id="element-103">
            <li data-id="element-104">copiar tendencias</li>
            <li data-id="element-105">publicar sin estrategia</li>
            <li data-id="element-106">hacer todo solos.</li>
          </ul>

          <div className="bg-red-900/20 border border-red-800/50 p-6 rounded-lg text-center" data-id="element-107">
            <p className="text-gray-400 uppercase tracking-widest text-sm mb-2" data-id="element-108">
              Resultado:
            </p>
            <p className="text-2xl md:text-3xl font-bold text-white" data-id="element-109">
              Confusión. Agotamiento. Abandono.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 6 - THE METHOD */}
      <section className="bg-[#0a0e2a] py-16 px-4" data-id="element-110">
        <div className="max-w-3xl mx-auto" data-id="element-111">
          <div className="text-center mb-12" data-id="element-112">
            <h3 className="text-3xl font-black text-white mb-4" data-id="element-113">
              🔥 Por eso creamos algo diferente
            </h3>
            <p className="text-xl text-gray-300" data-id="element-114">
              No un ebook más.{' '}
              <span className="font-bold text-cyan-400" data-id="element-115">
                Un sistema completo.
              </span>
            </p>
          </div>

          <div className="bg-[#0d1040] border-2 border-purple-700/50 rounded-2xl overflow-hidden shadow-[0_0_30px_rgba(100,50,200,0.2)] mb-12" data-id="element-116">
            <div className="bg-purple-900 text-white py-4 px-6 text-center" data-id="element-117">
              <h4 className="text-2xl font-bold uppercase tracking-wider" data-id="element-118">
                📚 EL MÉTODO INFLUENCER INVISIBLE
              </h4>
              <p className="text-purple-200 text-sm mt-1" data-id="element-119">5 TOMOS COMPLETOS</p>
            </div>

            <div className="p-6 md:p-8 space-y-6" data-id="element-120">
              <p className="text-center text-lg font-medium text-gray-300 mb-6" data-id="element-121">
                Un roadmap claro desde cero hasta construir una presencia
                digital real.
              </p>

              {[{
              title: 'TOMO 1 — IDENTIDAD DIGITAL',
              desc: 'La base antes del contenido.'
            }, {
              title: 'TOMO 2 — EL ARQUITECTO DEL AVATAR',
              desc: 'Diseñá una identidad visual coherente sin mostrarte.'
            }, {
              title: 'TOMO 3 — LA ILUSIÓN HUMANA',
              desc: 'Cómo generar conexión sin rostro.'
            }, {
              title: 'TOMO 4 — EL SISTEMA OPERATIVO',
              desc: 'Contenido sin bloqueo ni improvisación.'
            }, {
              title: 'TOMO 5 — ESCALA Y POSICIONAMIENTO',
              desc: 'Convertir presencia en oportunidades reales.'
            }].map((tomo, i) => <div key={i} className="flex items-start gap-4 p-4 bg-[#111640] rounded-lg shadow-sm border border-cyan-900/20 hover:border-cyan-600/40 transition" data-id="element-122">
                  <div className="bg-cyan-600 text-white font-bold w-8 h-8 rounded-full flex items-center justify-center shrink-0 mt-1" data-id="element-123">
                    {i + 1}
                  </div>
                  <div data-id="element-124">
                    <h5 className="font-bold text-white text-lg" data-id="element-125">
                      {tomo.title}
                    </h5>
                    <p className="text-gray-400" data-id="element-126">{tomo.desc}</p>
                  </div>
                </div>)}
            </div>
          </div>

          <CTAButton text="🔓 DESBLOQUEAR EL SISTEMA COMPLETO" className="max-w-xl" data-id="element-127" />
        </div>
      </section>

      {/* SECTION 7 - RESULTS */}
      <section className="bg-[#080c24] py-16 px-4" data-id="element-128">
        <div className="max-w-3xl mx-auto" data-id="element-129">
          <h3 className="text-3xl font-black text-center text-white mb-10" data-id="element-130">
            🔥 Lo que vas a lograr
          </h3>

          <div className="bg-[#111640] p-8 rounded-xl shadow-lg border border-cyan-900/30 space-y-4 mb-10" data-id="element-131">
            {['Saber exactamente qué crear.', 'Construir presencia sin exposición personal.', 'Crear contenido consistente sin esfuerzo mental constante.', 'Usar IA como herramienta, no como caos.', 'Construir algo que pueda monetizarse.'].map((item, i) => <div key={i} className="flex items-center gap-3 text-lg text-gray-200" data-id="element-132">
                <Check className="w-6 h-6 text-cyan-400 shrink-0" data-id="element-133" />
                <span data-id="element-134">{item}</span>
              </div>)}
          </div>

          <div className="text-center" data-id="element-135">
            <div className="flex justify-center text-yellow-400 mb-2" data-id="element-136">
              {[1, 2, 3, 4, 5].map(s => <Star key={s} className="w-6 h-6 fill-current" data-id="element-137" />)}
            </div>
            <p className="font-bold text-gray-400 mb-6" data-id="element-138">(+ 351 reseñas)</p>
            <p className="text-xl font-bold text-cyan-300 mb-8" data-id="element-139">
              Accedé ahora al sistema completo.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 8 - TESTIMONIALS */}
      <section className="bg-[#0d1040] py-16 px-4" data-id="element-140">
        <div className="max-w-3xl mx-auto" data-id="element-141">
          <h3 className="text-3xl font-black text-center text-white mb-10" data-id="element-142">
            Lo que dicen nuestros estudiantes
          </h3>
          <TestimonialsSection data-id="element-143" />
        </div>
      </section>

      {/* SECTION 9 - BONUSES */}
      <section className="bg-[#0a0e2a] py-16 px-4" data-id="element-144">
        <div className="max-w-3xl mx-auto" data-id="element-145">
          <div className="text-center mb-12" data-id="element-146">
            <h3 className="text-4xl font-black text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-red-500 uppercase tracking-tight" data-id="element-147">
              🎁 BONUS PREMIUM
            </h3>
            <p className="text-gray-400 font-bold mt-2" data-id="element-148">SOLO POR HOY</p>
          </div>

          <div className="space-y-12" data-id="element-149">
            {/* Bonus 1 */}
            <a href={PURCHASE_URL} className="block group" data-id="element-150">
              <div className="bg-[#111640] rounded-xl shadow-xl overflow-hidden border border-cyan-900/30 hover:border-cyan-500/50 hover:shadow-[0_0_20px_rgba(0,200,255,0.15)] transition transform hover:-translate-y-1" data-id="element-151">
                <div className="md:flex" data-id="element-152">
                  <div className="md:w-1/2 bg-[#0d1040]" data-id="element-153">
                    <img src={IMAGES.bonus1} alt="Prompt Master Pack" className="w-full h-full object-cover aspect-square" data-id="element-154" />
                  </div>
                  <div className="p-8 md:w-1/2 flex flex-col justify-center" data-id="element-155">
                    <span className="text-cyan-400 font-black uppercase tracking-widest text-sm mb-2" data-id="element-156">
                      BONUS #1
                    </span>
                    <h4 className="text-2xl font-bold text-white mb-2" data-id="element-157">
                      PROMPT MASTER PACK
                    </h4>
                    <p className="text-gray-400 mb-4" data-id="element-158">
                      Sistema profesional de prompts.
                    </p>
                    <div className="mt-auto" data-id="element-159">
                      <span className="inline-block bg-emerald-900/40 text-emerald-400 px-4 py-2 rounded-full font-bold text-sm border border-emerald-700/30" data-id="element-160">
                        🎁 GRATIS
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </a>

            {/* Bonus 2 */}
            <a href={PURCHASE_URL} className="block group" data-id="element-161">
              <div className="bg-[#111640] rounded-xl shadow-xl overflow-hidden border border-cyan-900/30 hover:border-cyan-500/50 hover:shadow-[0_0_20px_rgba(0,200,255,0.15)] transition transform hover:-translate-y-1" data-id="element-162">
                <div className="md:flex" data-id="element-163">
                  <div className="md:w-1/2 bg-[#0d1040]" data-id="element-164">
                    <img src={IMAGES.bonus2} alt="Biblioteca de Hooks" className="w-full h-full object-cover aspect-square" data-id="element-165" />
                  </div>
                  <div className="p-8 md:w-1/2 flex flex-col justify-center" data-id="element-166">
                    <span className="text-cyan-400 font-black uppercase tracking-widest text-sm mb-2" data-id="element-167">
                      BONUS #2
                    </span>
                    <h4 className="text-2xl font-bold text-white mb-2" data-id="element-168">
                      BIBLIOTECA DE HOOKS INVISIBLES
                    </h4>
                    <p className="text-gray-400 mb-4" data-id="element-169">
                      50 hooks diseñados para cuentas sin rostro.
                    </p>
                    <div className="mt-auto" data-id="element-170">
                      <span className="inline-block bg-emerald-900/40 text-emerald-400 px-4 py-2 rounded-full font-bold text-sm border border-emerald-700/30" data-id="element-171">
                        🎁 GRATIS
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </a>

            {/* Bonus 3 */}
            <a href={PURCHASE_URL} className="block group" data-id="element-172">
              <div className="bg-[#111640] rounded-xl shadow-xl overflow-hidden border border-cyan-900/30 hover:border-cyan-500/50 hover:shadow-[0_0_20px_rgba(0,200,255,0.15)] transition transform hover:-translate-y-1" data-id="element-173">
                <div className="md:flex" data-id="element-174">
                  <div className="md:w-1/2 bg-[#0d1040]" data-id="element-175">
                    <img src={IMAGES.bonus3} alt="Sistema 30 Días" className="w-full h-full object-cover aspect-square" data-id="element-176" />
                  </div>
                  <div className="p-8 md:w-1/2 flex flex-col justify-center" data-id="element-177">
                    <span className="text-cyan-400 font-black uppercase tracking-widest text-sm mb-2" data-id="element-178">
                      BONUS #3
                    </span>
                    <h4 className="text-2xl font-bold text-white mb-2" data-id="element-179">
                      SISTEMA 30 DÍAS + IA ESENCIAL
                    </h4>
                    <p className="text-gray-400 mb-4" data-id="element-180">
                      Calendario práctico + herramientas clave.
                    </p>
                    <div className="mt-auto" data-id="element-181">
                      <span className="inline-block bg-emerald-900/40 text-emerald-400 px-4 py-2 rounded-full font-bold text-sm border border-emerald-700/30" data-id="element-182">
                        🎁 GRATIS
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </section>

      {/* SECTION 10 - PRICING / OFFER */}
      <section id="compra" className="bg-[#060920] text-white py-16 px-4" data-id="element-183">
        <div className="max-w-3xl mx-auto text-center" data-id="element-184">
          <div className="inline-block border-2 border-yellow-400 text-yellow-400 px-6 py-2 font-bold text-xl uppercase tracking-widest mb-8 rounded" data-id="element-185">
            🔥 Oferta Limitada
          </div>

          <div className="mb-8" data-id="element-186">
            <p className="text-gray-400 text-xl mb-2" data-id="element-187">
              Precio normal:{' '}
              <span className="line-through decoration-red-500 decoration-2" data-id="element-188">
                $49.990
              </span>
            </p>
            <p className="text-2xl font-bold mb-4" data-id="element-189">HOY:</p>
            <p className="text-6xl md:text-8xl font-black text-yellow-400 tracking-tighter mb-2" data-id="element-190">
              $19.999
            </p>
          </div>

          <CountdownTimer data-id="element-191" />

          <div className="bg-[#0d1040] p-4 rounded-lg inline-block mb-8 border border-purple-800/40" data-id="element-192">
            <p className="text-lg font-semibold flex items-center justify-center gap-2" data-id="element-193">
              🎁 Cupos limitados disponibles.
            </p>
          </div>

          <div className="text-gray-400 text-sm mb-8 space-y-1 max-w-md mx-auto" data-id="element-194">
            <p data-id="element-195">Cuando el contador llega a cero:</p>
            <p className="text-red-400 font-bold" data-id="element-196">• el descuento desaparece</p>
            <p className="text-red-400 font-bold" data-id="element-197">
              • el acceso promocional se cierra
            </p>
            <p className="text-red-400 font-bold" data-id="element-198">
              • el cupo pasa a la siguiente persona.
            </p>
          </div>

          <CTAButton text="👉 QUIERO ACCEDER AHORA" subtext="Garantía de satisfacción de 7 días" data-id="element-199" />
        </div>
      </section>

      {/* SECTION 11 - MONETIZATION */}
      <section className="bg-[#0a0e2a] py-16 px-4" data-id="element-200">
        <div className="max-w-3xl mx-auto" data-id="element-201">
          <h3 className="text-3xl font-bold text-white mb-6 flex items-center gap-3" data-id="element-202">
            💡 Sobre la monetización
          </h3>

          <div className="bg-[#111640] p-8 rounded-xl border-l-4 border-cyan-500" data-id="element-203">
            <p className="text-lg text-gray-300 mb-4 font-medium" data-id="element-204">
              No es promesa mágica. Es estructura.
            </p>

            <div className="grid md:grid-cols-2 gap-8 mt-6" data-id="element-205">
              <div data-id="element-206">
                <p className="font-bold text-gray-200 mb-3 uppercase text-sm tracking-wider" data-id="element-207">
                  Cuando tenés:
                </p>
                <ul className="space-y-2 text-gray-300" data-id="element-208">
                  <li className="flex items-center gap-2" data-id="element-209">
                    <Check className="w-5 h-5 text-cyan-400" data-id="element-210" /> identidad clara
                  </li>
                  <li className="flex items-center gap-2" data-id="element-211">
                    <Check className="w-5 h-5 text-cyan-400" data-id="element-212" /> sistema
                  </li>
                  <li className="flex items-center gap-2" data-id="element-213">
                    <Check className="w-5 h-5 text-cyan-400" data-id="element-214" /> consistencia
                  </li>
                </ul>
              </div>

              <div data-id="element-215">
                <p className="font-bold text-gray-200 mb-3 uppercase text-sm tracking-wider" data-id="element-216">
                  Aparecen oportunidades:
                </p>
                <ul className="space-y-2 text-gray-300" data-id="element-217">
                  <li className="flex items-center gap-2" data-id="element-218">
                    <ArrowRight className="w-4 h-4 text-emerald-400" data-id="element-219" />{' '}
                    productos digitales
                  </li>
                  <li className="flex items-center gap-2" data-id="element-220">
                    <ArrowRight className="w-4 h-4 text-emerald-400" data-id="element-221" /> cuentas
                    nicho
                  </li>
                  <li className="flex items-center gap-2" data-id="element-222">
                    <ArrowRight className="w-4 h-4 text-emerald-400" data-id="element-223" />{' '}
                    colaboraciones
                  </li>
                  <li className="flex items-center gap-2" data-id="element-224">
                    <ArrowRight className="w-4 h-4 text-emerald-400" data-id="element-225" />{' '}
                    proyectos propios
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 12 - FAQ */}
      <section className="bg-[#0a0e2a] py-16 px-4 border-t border-cyan-900/20" data-id="element-226">
        <div className="max-w-3xl mx-auto" data-id="element-227">
          <h3 className="text-3xl font-black text-center text-white mb-10" data-id="element-228">
            ❗ PREGUNTAS FRECUENTES
          </h3>

          <div className="space-y-4" data-id="element-229">
            {[{
            q: '¿Tengo que mostrar mi cara?',
            a: 'No. El sistema está diseñado específicamente para funcionar sin exposición personal.'
          }, {
            q: '¿Sirve si empiezo desde cero?',
            a: 'Sí. El Tomo 1 y 2 cubren toda la base necesaria para arrancar sin experiencia previa.'
          }, {
            q: '¿Necesito saber IA?',
            a: 'No. Te enseñamos las herramientas y prompts exactos que necesitás usar.'
          }, {
            q: '¿Acceso inmediato?',
            a: 'Sí. Apenas completás la compra recibís el acceso a todo el material y los bonos.'
          }].map((faq, i) => <div key={i} className="border border-cyan-900/30 rounded-lg p-6 hover:border-cyan-600/40 hover:shadow-md transition bg-[#111640]" data-id="element-230">
                <p className="font-bold text-lg text-white mb-2" data-id="element-231">{faq.q}</p>
                <p className="text-gray-400" data-id="element-232">{faq.a}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECTION 13 - FINAL CTA */}
      <section className="bg-[#060920] text-white py-20 px-4" data-id="element-233">
        <div className="max-w-3xl mx-auto text-center" data-id="element-234">
          <h3 className="text-4xl font-black mb-6" data-id="element-235">🚀 Empezá hoy</h3>
          <p className="text-xl text-gray-300 mb-10" data-id="element-236">
            No esperes sentirte listo. Empezá con dirección.
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12 text-sm font-bold text-gray-300" data-id="element-237">
            <div className="flex flex-col items-center gap-2" data-id="element-238">
              <Check className="w-8 h-8 text-cyan-400" data-id="element-239" />
              <span data-id="element-240">Acceso inmediato</span>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-241">
              <Check className="w-8 h-8 text-cyan-400" data-id="element-242" />
              <span data-id="element-243">Sistema completo (5 tomos)</span>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-244">
              <Check className="w-8 h-8 text-cyan-400" data-id="element-245" />
              <span data-id="element-246">Sin mostrar tu cara</span>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-247">
              <ShieldCheck className="w-8 h-8 text-cyan-400" data-id="element-248" />
              <span data-id="element-249">Garantía 7 días</span>
            </div>
          </div>

          <CTAButton text="👉 QUIERO EMPEZAR AHORA" data-id="element-250" />

          <div className="mt-12 pt-8 border-t border-cyan-900/30 text-gray-500 text-sm" data-id="element-251">
            <p data-id="element-252">
              © 2026 El Influencer Invisible. Todos los derechos reservados.
            </p>
            <p className="mt-2" data-id="element-253">
              Este sitio no es parte del sitio web de Facebook o Facebook Inc.
              Además, este sitio no está respaldado por Facebook de ninguna
              manera.
            </p>
          </div>
        </div>
      </section>
    </div>;
}